import React from 'react';

import Badge from '../Badge';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function MapTypeBadge({ mapType, className }) {
  if (!mapType) {
    return null;
  }
  const title = mapType === 'map' ? StringConstantsMixin.strings.MAP : StringConstantsMixin.strings.RECORDING;
  return (
    <Badge title={title} className={className}>
      {title}
    </Badge>
  );
}
